type UseScrollBehaviourBody = {
	lockBody: () => void;
	unlockBody: () => void;
};

const lockBody = (): void => {
	document.body.style.overflow = "hidden";
	const scrollbarWidth = Math.abs(window.innerWidth - document.documentElement.clientWidth);
	if (scrollbarWidth) document.body.style.paddingRight = `${scrollbarWidth}px`;
};

const unlockBody = (): void => {
	document.body.style.overflow = "";
	document.body.style.paddingRight = "";
};

export default function useScrollBehaviourBody(): UseScrollBehaviourBody {
	return {
		lockBody,
		unlockBody,
	};
}
